import React from "react";
import { Button, Modal } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";

export default function SendMarketingEmailConfirmModal({
  show,
  contact,
  recipient,
  lastSent,
  savesChanges,
  sending,
  onCancel,
  onConfirm,
}) {
  return (
    <Modal show={show} onHide={onCancel} centered className="custome-modal">
      <div className="message-container custome-msg-container">
        <div className="message-header-box">
          <h4>Confirm Send</h4>
          <div className="messages-modal-actions">
            <Button className="btn" onClick={onCancel}>
              <FaTimes />
            </Button>
          </div>
        </div>
        <div className="message-body">
          <p>
            Are you sure you want to send the marketing email to{" "}
            <strong>{recipient ? recipient.name : contact?.contact_name}</strong> at{" "}
            <strong>{recipient ? recipient.email : contact?.contact_email}</strong> for{" "}
            <strong>{contact?.group_name}</strong>?
          </p>
          {lastSent && (
            <p className="text-warning">
              Already sent on {lastSent}. This sends it again.
            </p>
          )}
          {/* A send from the Edit dialog is recorded by saving the contact,
              which also saves anything else changed in the dialog. */}
          {savesChanges && (
            <p className="text-muted mb-0">
              This also saves your other changes to this contact.
            </p>
          )}
        </div>
        <div className="message-footer text-right" style={{ display: "block" }}>
          <Button
            variant="secondary"
            type="button"
            size="xs"
            onClick={onCancel}
            disabled={sending}
            className="mr-2"
          >
            Cancel
          </Button>
          <Button
            variant="success"
            type="button"
            size="xs"
            onClick={onConfirm}
            disabled={sending}
          >
            {sending ? "Sending..." : "Send"}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
